<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card>
          <v-toolbar color="primary">
            <v-toolbar-title>{{ $t("login.auth") }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="login"
                :label="$t('login.id')"
                :rules="[rules.required]"
                prepend-icon="person"
                type="text"
                :autofocus="true"
              />
              <v-text-field
                v-model="pwd"
                prepend-icon="lock"
                :append-icon="show ? 'visibility' : 'visibility_off'"
                :rules="[rules.required, rules.min]"
                :type="show ? 'text' : 'password'"
                :label="$t('login.password')"
                :hint="$t('field.min-8')"
                counter
                @click:append="show = !show"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-checkbox
              v-model="remember"
              :label="$t('login.remember')"
            />
            <v-spacer />
            <v-btn
              color="success"
              :disabled="login.length < 6 || pwd.length < 8"
              @click="connect()"
            >
              {{ $t("login.login") }}
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-alert
          v-if="error.notFound"
          type="warning"
        >
          {{ $t("login.not-found") }}
        </v-alert>
        <v-alert
          v-if="error.errConnect"
          type="warning"
        >
          {{ $t("login.error-connect") }}
        </v-alert>
        <v-alert
          v-if="error.errConnect"
          type="error"
        >
          {{ $t("login.error-connect-tooltip") }}
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Connectors
import { LoginConnector } from "./Database/LoginConnector.js";
import { ProfileLogConnector } from "./Database/ProfileLogConnector.js";
//import { ProfileMailTransferConnector } from './Database/ProfileMailTransferConnector.js';

// Tools
const md5 = require("md5");

export default {
  data() {
    return {
      loginConnector: new LoginConnector(),
      login: "",
      pwd: "",
      senderData: "",
      rules: {
        required: (value) => !!value || this.$t("field.required"),
        min: (v) => v.length >= 8 || this.$t("field.min-8"),
      },
      show: false,
      remember: true,
      error: {
        notFound: false,
        errConnect: false,
      },
    };
  },
  created() {
    document.title = this.$t("appname");
    this.$store.state.navigationBar.titleName = "";
  },
  mounted() {
    this.setupKeys();

    if (localStorage.login !== undefined && localStorage.password !== undefined) {
      // if last connect older than 8 days (691200000 ms) - remove pwd and disable autoconnect
      if (localStorage.expire < Date.now() - 691200000) {
        localStorage.password = "";
        localStorage.disconnected = true;
      }

      this.login = localStorage.login;
      this.pwd = localStorage.password;

      // autologin if remember me
      if (localStorage.disconnected != "true") {
        this.connect();
      } else {
        localStorage.disconnected = false;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener("keydown", this.connectKeys);
    next();
  },
  methods: {
    connectKeys(e) {
      if (e.keyCode == "13") {
        this.connect();
      }
    },
    connect() {
      this.loginConnector
        .getLoginData(this.login, this.pwd)
        .then((userObj) => {
          if (userObj.length > 0) {
            this.error.notFound = false;
            this.error.errConnect = false;

            userObj.forEach((data) => {
              let pAccess = [];

              if (data.players !== null) {
                pAccess = data.players.split("|").map((player) => {
                  return parseInt(player);
                });
              }

              userObj = {
                uid: data.id_usr,
                sid: data.soc_id,
                rid: data.right_id,
                name: data.firstname + " " + data.lastname,
                login: data.login,
                permissions: data.permissions,
                dir: data.dir,
                players: pAccess,
                aikido: data.aikido,
                token: data.token,
              };
            });

            if (this.remember) {
              localStorage.login = this.login;
              localStorage.password = this.pwd;
              localStorage.expire = Date.now();
            } else {
              localStorage.clear();
            }

            const user = {
              userId: userObj.uid,
              socId: userObj.sid,
              rightId: userObj.rid,
              name: userObj.name,
              login: userObj.login,
              permissions: userObj.permissions,
              dir: userObj.dir,
              players: userObj.players,
              aikido: userObj.aikido,
              token: userObj.token,
            };

            // Make a function insert connect log with params
            const profilConnector = new ProfileLogConnector(user);
            profilConnector.insertConnectionLog();
            this.$store.dispatch("authentified", user).user;

            if (md5(this.$store.state.user.aikido) == "bc4634dcd9303d59bace805e02472bcd") {
              this.$router.push({ path: "/minato" });
            } else if (user.permissions == 0) {
              this.$router.push({ path: "/viewer" });
            } else {
              this.$router.push({ path: "/home" });
            }
          } else {
            this.error.errConnect = false;
            this.error.notFound = true;
          }
        })
        .catch((err) => {
          // TODO: maybe we can precise that the user firewall can block it
          this.error.errConnect = true;
          this.error.notFound = false;
          console.error(err);
        });
    },
    setupKeys() {
      window.addEventListener("keydown", this.connectKeys);
    },
  },
};
</script>

<style></style>
